module.exports = __webpack_public_path__ + "static/CalibreWeb-Regular-6e1cfd6db2787108c834cb839ec76e4e.eot";